/* El Laguito — < > arrows on the product gallery's main picture (2026-11-02, Zein). All brands.
   Works with Dawn's media-gallery: desktop shows one picture at a time (setActiveMedia),
   phones scroll the slider. Styles: assets/elc-gallery.css
   2026-11-03: pinch-zoom guard — see the end of setup(). */
(function () {
  if (window.__elcGallery) return;
  window.__elcGallery = true;
  var arrow = function (d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="' + (d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
  };
  function setup(g) {
    if (g.__elcGal) return;
    var viewer = g.querySelector('[id^="GalleryViewer"]');
    var list = viewer && viewer.querySelector('.product__media-list');
    if (!viewer || !list) return;
    g.__elcGal = true;
    var items = function () { return Array.prototype.slice.call(list.querySelectorAll('.product__media-item[data-media-id]')); };
    var mql = window.matchMedia('(min-width: 750px)');
    var current = function () {
      var li = items();
      if (!mql.matches) {
        /* phone: the slide nearest the scroll position */
        var best = 0, bd = Infinity;
        li.forEach(function (el, i) { var d = Math.abs(el.offsetLeft - list.scrollLeft); if (d < bd) { bd = d; best = i; } });
        return best;
      }
      for (var i = 0; i < li.length; i++) if (li[i].classList.contains('is-active')) return i;
      return 0;
    };
    var count = document.createElement('div');
    count.className = 'elc-gal__count';
    var paint = function () { var li = items(); count.textContent = (current() + 1) + ' / ' + li.length; };
    var go = function (step) {
      var li = items();
      if (li.length < 2) return;
      var idx = (current() + step + li.length) % li.length;
      if (typeof g.setActiveMedia === 'function') g.setActiveMedia(li[idx].dataset.mediaId, false);
      else li.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
      if (!mql.matches) list.scrollTo({ left: li[idx].offsetLeft, behavior: 'smooth' });
      setTimeout(paint, 60);
    };
    var mk = function (cls, d, label) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'elc-gal__nav ' + cls; b.setAttribute('aria-label', label); b.innerHTML = arrow(d);
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(d); });
      return b;
    };
    viewer.style.position = 'relative';
    viewer.appendChild(mk('elc-gal__prev', -1, 'Previous image'));
    viewer.appendChild(mk('elc-gal__next', 1, 'Next image'));
    viewer.appendChild(count);
    if (items().length < 2) list.classList.add('elc-gal--single');
    list.addEventListener('scroll', function () { clearTimeout(list.__elcT); list.__elcT = setTimeout(paint, 80); }, { passive: true });
    g.addEventListener('click', function (e) { if (e.target.closest('.thumbnail-list__item')) setTimeout(paint, 60); });
    paint();
    /* 2026-11-03 (Zein): pinch-zooming the picture must not change the picture. While two fingers are down, or the
       page is zoomed in, the phone slider is locked (no sideways scroll) and put back on the picture it was showing. */
    var held = -1;
    var zoomed = function () { return !!(window.visualViewport && window.visualViewport.scale > 1.01); };
    var lock = function (on) {
      if (on) { if (held < 0) held = current(); list.classList.add('elc-gal--zoomlock'); return; }
      if (held < 0) return;
      list.classList.remove('elc-gal--zoomlock');
      var li = items(), idx = held; held = -1;
      if (!mql.matches && li[idx]) list.scrollTo({ left: li[idx].offsetLeft, behavior: 'auto' });
      setTimeout(paint, 60);
    };
    g.addEventListener('touchstart', function (e) { if (e.touches.length > 1) lock(true); }, { passive: true });
    document.addEventListener('touchend', function (e) { if (e.touches.length === 0 && !zoomed()) lock(false); }, { passive: true });
    document.addEventListener('touchcancel', function (e) { if (e.touches.length === 0 && !zoomed()) lock(false); }, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { if (zoomed()) lock(true); else lock(false); });
  }
  function run() { document.querySelectorAll('media-gallery').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
